import { BitkitCodeSnippet } from '@bitrise/bitkit-v2';
import { Box } from '@chakra-ui/react/box';
import { Text } from '@chakra-ui/react/text';

// Test cases grouped by class sit in a suite named after their class, which the class name snippet already shows.
const withoutTrailingClassName = (breadcrumb?: string, className?: string) => {
  if (!breadcrumb || !className) {
    return breadcrumb;
  }
  if (breadcrumb === className) {
    return undefined;
  }

  const classNameSegment = ` / ${className}`;
  return breadcrumb.endsWith(classNameSegment) ? breadcrumb.slice(0, -classNameSegment.length) : breadcrumb;
};

const Breadcrumb = ({ breadcrumb, testCaseClassName }: { breadcrumb?: string; testCaseClassName?: string }) => {
  const path = withoutTrailingClassName(breadcrumb, testCaseClassName);

  return (
    <Box display="flex" alignItems="center" justifyContent="start" flexWrap="wrap" columnGap="4">
      {path && (
        <Text textStyle="comp/link/md" color="text/secondary" truncate>
          {testCaseClassName ? `${path} •` : path}
        </Text>
      )}
      {testCaseClassName && (
        <Box minW="0" mr="32" mt="-4" overflow="hidden" textOverflow="ellipsis">
          <BitkitCodeSnippet size="md" variant="inline" interactive>
            {testCaseClassName}
          </BitkitCodeSnippet>
        </Box>
      )}
    </Box>
  );
};

export default Breadcrumb;
